module.exports = __webpack_public_path__ + "static/img/service_introduce_5122_zh_h5.a7e628b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_5122_zh_h5.png
// module id = hELw
// module chunks = 34